import classNames from "classnames";

import {Loader} from "./Loader";

interface LoadingContainerProps {
  text?: string;
  className?: string;
}

export const LoadingContainer = ({text = "Loading…", className}: LoadingContainerProps) => (
  <div className={classNames("text-center mt-5", className)}>
    <Loader text={text} />
  </div>
);
